module.exports = __webpack_public_path__ + "static/media/03-10WHEELS_STALL.27d610b5.png";